import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "invoice-surcharge-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InvoiceItemMenu = _resolveComponent("InvoiceItemMenu")!
  const _component_NrModal = _resolveComponent("NrModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.totalSelectedSurchargeItems, (surcharge, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "invoice-surcharge-container",
        key: `surcharge_${index}`
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", null, _toDisplayString($options.setSurchargeLabel(surcharge)), 1),
          _createElementVNode("div", null, [
            _createTextVNode(_toDisplayString($options.formatSurcharge(surcharge)) + " ", 1),
            _createVNode(_component_InvoiceItemMenu, {
              onOnEdit: ($event: any) => ($options.onEdit(surcharge, index)),
              onOnDelete: ($event: any) => ($options.onDelete(surcharge))
            }, null, 8, ["onOnEdit", "onOnDelete"])
          ])
        ])
      ]))
    }), 128)),
    _createVNode(_component_NrModal, {
      show: $options.activeSurchargeDeleteModal,
      primaryButtonText: "Delete fee/discount",
      secondaryButtonText: "Cancel",
      title: "Delete fee/discount",
      hasSecondaryButton: "",
      onOnPrimaryClick: $options.deleteInvoiceSurchargeItem,
      onOnSecondaryClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setActiveModal(''))),
      onOnCloseClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setActiveModal('')))
    }, {
      default: _withCtx(() => [
        _createElementVNode("p", null, " Are you sure you want to remove " + _toDisplayString(this.invoiceItemToEdit?.label) + " from the list? ", 1)
      ]),
      _: 1
    }, 8, ["show", "onOnPrimaryClick"])
  ], 64))
}